import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import {
  categoriesRequest,
  onClickRow,
  onClickAssignToIngredient,
} from 'actions/ingredients/category';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import * as actOutletPage from 'actions/outletPages/list';
import Pusher from 'pusher-js';
import {
  PUSHER_APP_KEY,
  INVENTORY_BUSINESS_PUSHER_CHANNEL,
  INVENTORY_CLONE_OUTLET_PUSHER_EVENT,
} from 'api/constants';
import styles from './List.css';

class List extends React.Component {
  componentDidMount() {
    const { businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(
      INVENTORY_BUSINESS_PUSHER_CHANNEL(businessId)
    );
  }

  componentDidUpdate() {
    const { dispatch } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    this.channel.bind(INVENTORY_CLONE_OUTLET_PUSHER_EVENT, data => {
      dispatch(actOutletPage.checkCloningOutletOnProgress(data));
    });
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const { categories, categoryDetail, showLoadingSpinnerPage } = this.props;
    if (categories.length > 0) {
      return (
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th>Ingredient Category Name</th>
                <th>Ingredient Stocks</th>
                <th />
              </tr>
            </thead>
          </table>
          <div
            className={`${
              styles['table-content-wrapper']
            } ingredient-categories-table-content-wrapper`}
          >
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={`${styles['table-content']}`}>
                <tbody>
                  {categories.map(category => {
                    const className =
                      categoryDetail && category.id === categoryDetail.id
                        ? styles.selected
                        : '';
                    return (
                      <tr
                        key={category.id}
                        onClick={() => {
                          this._onClickRow(category);
                        }}
                        className={className}
                      >
                        <td>{category.name}</td>
                        <td>{category.ingredient_count} ingredients</td>
                        <td className="text-right">
                          <a
                            className="btn btn-default"
                            onClick={event =>
                              this._onClickAssignToIngredient(event, category)
                            }
                          >
                            Assign to Ingredient
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      );
    }
    return (
      <NoDataAndLoading
        showLoadingSpinner={showLoadingSpinnerPage}
        noDataToDisplay={categories.length === 0}
        title="No Data To Display"
        description=""
        linkLabel="Create Ingredient Categories"
        linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/115004530194"
      />
    );
  }

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  _onReachBottom = () => {
    const { dispatch, currentPage, categories } = this.props;
    dispatch(categoriesRequest({ page: currentPage + 1 }, categories));
  };

  _onClickRow = category => {
    const { dispatch, isDirtyForm } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickRow(category)));
    } else {
      dispatch(onClickRow(category));
    }
  };

  _onClickAssignToIngredient = (event, category) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.dispatch(onClickAssignToIngredient(category));
  };
}

function mapStateToProps(state) {
  const {
    categories,
    totalPage,
    currentPage,
    categoryDetail,
  } = state.ingredients.category;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    categories,
    totalPage,
    currentPage,
    showLoadingSpinnerPage,
    categoryDetail,
    isDirtyForm: isDirty('ingCategory')(state),
    businessId: state.moka.user.business.id,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
